export default function StatusBadge({ status }) {
    const styles = {
        active: "bg-green-100 text-green-800 border-green-200",
        inactive: "bg-gray-100 text-gray-600 border-gray-200",
        trash: "bg-red-100 text-red-800 border-red-200",
    };

    const dotColors = {
        active: "bg-green-500",
        inactive: "bg-gray-400",
        trash: "bg-red-500",
    };

    if (!status) return null;

    const statusLower = status?.toLowerCase();

    return (
        <span
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${
                styles[statusLower] || styles.inactive
            }`}
        >
            <div
                className={`w-1.5 h-1.5 rounded-full mr-1.5 ${
                    dotColors[statusLower] || "bg-gray-400"
                }`}
            />
            {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
    );
}
